module.exports = __webpack_public_path__ + "img/icon4.126520ec.png";